import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React__default, { useCallback } from 'react';
import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';
import TextCellRenderer from './TextCellRenderer.js';
import SpriteIcon from '../../../SpriteIcon/SpriteIcon.js';

const Root = styled(MuiBox) `
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
`;
const CellContainer = styled('div') `
  display: flex;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  overflow: hidden;

  > svg {
    min-width: 44px;
    padding-left: 18px;
  }
`;
const IconContainer = styled(MuiBox, {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  display: flex;
  position: relative;
  ${({ theme, rtl }) => `
    padding: ${rtl ? theme.spacing(0, 0, 0, 2.5) : theme.spacing(0, 2.5, 0, 0)};
  `};
`;
const ValueContainer = styled('div') `
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
`;
const ActionIcons = styled('div') `
  display: flex;
  margin-left: 8px;
  background-color: transparent !important;
  transition-property: all;
  position: absolute;
  left: -9999px;
  opacity: 0;

  > svg {
    cursor: pointer;
    opacity: 0.8;
    min-width: 18px;
    margin: ${({ theme }) => theme.spacing(0, 3.5, 0, 0)};

    &:hover {
      opacity: 1;
    }
  }
`;
const TextWithActionsOnHoverRenderer = React__default.memo((_a) => {
    var { Icon, iconName, state, cell, actions, row } = _a, rest = __rest(_a, ["Icon", "iconName", "state", "cell", "actions", "row"]);
    const onActionClick = useCallback((name, onClick, e) => {
        e.stopPropagation();
        onClick(row, name, e);
    }, [row]);
    return (jsx(Root, { children: jsxs(CellContainer, { children: [(Icon || iconName) && (jsx(IconContainer, Object.assign({ rtl: rest.rtl }, { children: Icon ? jsx(Icon, {}) : iconName ? jsx(SpriteIcon, { name: iconName }) : null }))), jsx(ValueContainer, { children: jsx(TextCellRenderer, Object.assign({}, rest, { state: state, cell: cell, row: row, relative: true })) }), actions ? (jsx(ActionIcons, Object.assign({ className: "ops-cell-action-items" }, { children: actions.map(({ name, Icon, iconName, onClick }) => Icon ? (jsx(Icon, { onClick: (e) => onActionClick(name, onClick, e) }, name)) : iconName ? (jsx(SpriteIcon, { name: iconName, onClick: (e) => onActionClick(name, onClick, e) }, name)) : null) }))) : null] }) }));
});
TextWithActionsOnHoverRenderer.displayName = 'TextWithActionsOnHoverRenderer';

export { TextWithActionsOnHoverRenderer as default };
//# sourceMappingURL=TextWithActionsOnHoverRenderer.js.map
